var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg263A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDD67",
    cx: 32,
    cy: 32,
    r: 30
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#664E27",
    cx: 20.5,
    cy: 24.592,
    r: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#664E27",
    cx: 43.5,
    cy: 24.592,
    r: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M48.111 37.02C43.783 43.127 38.66 44.664 32 44.664s-11.783-1.537-16.111-7.645c-.602-.85-2.189-.314-1.839.92C16.323 45.943 24.051 50.605 32 50.605s15.677-4.662 17.95-12.666c.351-1.234-1.237-1.769-1.839-.919z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg263A);
export default __webpack_public_path__ + "static/media/263a.1a3b1b4b40b6535a50d1863e1d91f45f.svg";
export { ForwardRef as ReactComponent };